import { RemoteConfigProperties } from "../../../..";
import { NotImplementedError } from "../../../../errors";
import { PACING_ENDPOINT, parsePacingApiResponse, parsePacingV2Response, resolvePacingDateRange, toPacingApiRequest } from "../../../../models/looker/modules/pacingV2";
import { DateTime } from "luxon";
import { PromiseHandler } from "../../../../handlers";
import { PACING_QUERY } from "./query";
import { toEmbedHash } from "../../../../models/looker/query";
class Pacing extends PromiseHandler {
    constructor(sdk) {
        // Pacing data refreshes roughly hourly; cache for 10 min (ttl is in seconds).
        super(sdk, "looker-pacing", { ttl: 600 });
    }
    async findItems(filters) {
        if (this.sdk.featureFlags.isFlagEnabled(RemoteConfigProperties.REPORTING_API_PACING)) {
            return this.findItemsFromReportingApi(filters);
        }
        // Shared with the endpoint request builder so both transports accept the
        // same inputs and refuse with the same message.
        const dateRange = resolvePacingDateRange(filters);
        const queryBody = {
            ...PACING_QUERY,
            filters: this.filters(dateRange)
        };
        const hashKey = `looker:${await this.sdk.looker.query.hashQuery(queryBody)}`;
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: parsePacingV2Response(data),
                queryMeta
            }
        ])
            .catch(() => {
            throw new Error("Failed to fetch pacing data");
        }));
    }
    /**
     * The same campaigns through the reporting API instead of the Looker SDK, in
     * the same shape, so no caller can tell which source answered.
     *
     * The endpoint returns flat line-item rows; the grouping, the rollup and the
     * derived pace and time statuses stay client-side, shared with the Looker path.
     *
     * A failure is surfaced rather than retried through Looker, so a broken
     * endpoint cannot present as working — and unlike the Looker path it keeps its
     * type, since a refusal names the fields and filters it refused.
     */
    async findItemsFromReportingApi(filters) {
        const request = toPacingApiRequest(filters);
        // Namespaced by transport: the cache outlives a mid-session flag flip, and
        // persistent caching outlives the session, so an unnamespaced key could
        // serve rows fetched through the other transport.
        const hashKey = `api:${await this.sdk.looker.query.hashQuery(request)}`;
        return this.cache.promise(hashKey, () => this.sdk.looker.reporting
            .query(PACING_ENDPOINT, request, "Failed to fetch pacing data.")
            .then(({ data, query }) => [
            {
                data: parsePacingApiResponse(data),
                queryMeta: { embedHash: toEmbedHash(query?.share_url) }
            }
        ]));
    }
    filters(dates) {
        return {
            ...PACING_QUERY.filters,
            "vw_dim_lineitem.flt_analysis_interval": dates
                .map((d) => DateTime.fromJSDate(d).toFormat("yyyy/MM/dd"))
                .join(" to ")
        };
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
export default Pacing;
//# sourceMappingURL=index.js.map